import { useCustomReducer } from '../../../../../base/customHooks'
import IPButton from '../../../../../components/IPButton'
import { useEffect, useMemo, useState } from 'react'
import '../../AccountSummary/AccountSummary.scss'
import Swal from 'sweetalert2'
import InputCampaign from '../../../../../components/InputCampaign'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import { exportToXLSX, exportToXLSXVDF, formatCurrencyTemlik, formatDate } from '../../../../../base/utils/dataHelper'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import IPExcelButton from '../../../../../components/IPExcelButton'
import Table from '../../../../../components/Table'
import { GetVodafonePKRequest, GetVodafonePKResponse, GetVodafoneTemlikHesaplasmaResponse } from '../models/model'
import '../../AccountSummary/AccountSummary.scss'
import moment from 'moment'
import IPDatePicker from '../../../../../components/IPDatePicker'
import { date } from 'yup'
import { GetHesaplasmaApi } from '../services/getHesaplasma'

interface IVodafonePKState {
  companyOptions: ISelectOption[]
  imei?: string
  fi?: string
}

function VodafoneTemlikHesaplasma(props: BaseComponentWithContextProps) {
  const getInitialState = (): IVodafonePKState => {
    return {
      companyOptions: []
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IVodafonePKState>(intialState)
  const [pkData, setPkData] = useState<GetVodafoneTemlikHesaplasmaResponse[]>([])

  const [startDate, setStartDate] = useState(undefined)
  const [endDate, setEndDate] = useState(undefined)
  const toDateTimeLocal = date => {
    return date
      ?.toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      })
      ?.replace(' ', 'T')
  }

  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [currentPage, setCurrentPage] = useState(0)

  const getPK = async () => {
    const req: GetVodafonePKRequest = {
      StartDate: startDate && formatDate(startDate),
      EndDate: endDate && formatDate(endDate),
      BelgeNo: state.fi,
    }
    props.showLoading()
    const getPoDoc: GetHesaplasmaApi = new GetHesaplasmaApi({})
    getPoDoc
      .getList(req)
      .then(result => {
        if (result) {
          setPkData(result)
          if (result.length === 0) {
            Swal.fire({
              icon: 'warning',
              title: 'Temlik verisi bulunamadı',
              showConfirmButton: true,
              allowOutsideClick: false,
            })
          }
          props.hideLoading()
        } else {
          console.warn('Temlik result is empty.')
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        if (!err.description || err.description === 'OK') {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: 'PK verisi bulunamadı',
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        } else {
          props.hideLoading()
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        }
      })
    return
  }

  // Tablo başlıkları
  const columnDefinitions = [
    { Header: 'Belge No', accessor: 'belgeNo' },
    { Header: 'Referans No', accessor: 'refNo' },
    { Header: 'Belge Türü', accessor: 'belgeTuru' },
    { Header: 'Şirket', accessor: 'company' },
    { Header: 'Yıl', accessor: 'yil' },
    { Header: 'Tarih', accessor: 'tarih' },
    { Header: 'Tutar', accessor: 'fiyat' },
    { Header: 'Para Birimi', accessor: 'pb' },

  ]

  const tableColumns = useMemo(() => columnDefinitions, [])

  const tableDataAndTotal = useMemo(() => {
    const tableData = pkData.map((item, index) => {
      const data = {
        belgeNo: item.BELGE_NO,
        tarih: item.TARIH ? moment(item.TARIH).format('DD.MM.YYYY') : item.TARIH,
        yil: item.YIL,
        fiyat: <div style={{ textAlign: 'right' }}>{formatCurrencyTemlik(item.TUTAR)}</div>,
        pb: item.PARA_BIRIMI,
        belgeTuru: item.BELGE_TURU,
        refNo: item.REF_NO,
        company: item.SIRKET,
        bayiKodu: item.BAYI_KODU,
      }
      return data
    })
    return {
      tableData,
    }
  }, [pkData])

  const excelButton = async () => {
    try {
      if (pkData) {
        const data: any[] = []
        if (pkData.length > 0) {
          pkData.map((item, index) => {
            return data.push({
              "BELGE NO": item.BELGE_NO,
              "REFERANS NO": item.REF_NO,
              "BELGE TÜRÜ": item.BELGE_TURU,
              "ŞİRKET": item.SIRKET,
              "YIL": item.YIL,
              "TARİH": item.TARIH ? moment(item.TARIH).format('DD.MM.YYYY') : item.TARIH,
              "TUTAR": formatCurrencyTemlik(item.TUTAR),
              "PARA BİRİMİ": item.PARA_BIRIMI,
            })
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Excele atılacak veri bulunmamaktadır.',
            allowOutsideClick: true,
            backdrop: true,
          })
          return
        }
        exportToXLSXVDF(data, 'Temlik Hesaplaşma', 'G')
      }
    } catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }

  return (
    <div className='Reports'>
      <div className='heading-text d-flex justify-content-between align-items-center'>
        <h4 style={{ textAlign: 'center' }}>Temlik Takip</h4>
        <div className='d-flex align-items-center'>
          <IPExcelButton onClick={excelButton} />
        </div>
      </div>
      <form>
        <div className='form-row' style={{ display: 'flex', justifyContent: 'center' }}>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='StartDate'
              name='StartDate'
              label={'Başlangıç Tarihi'}
              value={toDateTimeLocal(startDate)}
              onChange={e => getDate(e.target.value, 'Start')}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='date'
              id='EndDate'
              name='EndDate'
              label={'Bitiş Tarihi'}
              value={toDateTimeLocal(endDate)}
              onChange={e => getDate(e.target.value, 'End')}
              isActive
            />
          </div>
          <div className='form-group col-md-2'>
            <InputCampaign
              type='text'
              id='FI'
              name='FI'
              label={'Belge No'}
              value={state.fi}
              onChange={e => setState({ fi: e.target.value })}
              isActive
            />
          </div>
          <div className='form-group col-md-3' style={{ justifyContent: 'center', display: 'flex' }}>
            <IPButton
              text='Listele'
              className='button'
              onClick={() => getPK()}
              style={{
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '10px',
                width: '150px',
                height: '50px',
              }}
            />
          </div>
        </div>
      </form>
      <div className='m-4'>
        <Table
          columns={tableColumns}
          data={tableDataAndTotal.tableData}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
          columnCount={13}
          backgroundColor='red'
          color='white'
        />
      </div>
    </div>
  )
}
export default componentWithContext(VodafoneTemlikHesaplasma)
